export type BenchDetailTabId =
  | "main"
  | "batch-tests"
  | "firmware-testing"
  | "documentation"
  | "settings"
  | "command-docs";

export const BENCH_DETAIL_TABS: ReadonlyArray<{ id: BenchDetailTabId; label: string }> = [
  { id: "main", label: "Main" },
  { id: "batch-tests", label: "Batch Tests" },
  { id: "firmware-testing", label: "Firmware testing" },
  { id: "documentation", label: "Documentation" },
  { id: "settings", label: "Settings" },
  { id: "command-docs", label: "Command Docs" },
];
